import React from 'react'

import ESignatureUnderstandingCheckbox from '@/components/misc/ReferralESignatureConsentPdf/components/ESignatureUnderstandingCheckbox'
import PdfSection from '@/components/misc/ReferralESignatureConsentPdf/components/PdfSection'
import SignatureBox from '@/components/misc/ReferralESignatureConsentPdf/components/SignatureBox'
import { SIGNATURE_BOX_ID } from '@/components/misc/ReferralESignatureConsentPdf/constants'
import ReferralESignatureConsentPdf from '@/components/misc/ReferralESignatureConsentPdf/ReferralESignatureConsentPdf'
import { DATE_FORMATS } from '@/lib/constants'
import { formatDate } from '@/lib/helpers/dateHelpers'
import { ReferralConsentStage } from '@/types/misc'

interface Props {
  referral: React.ComponentProps<
    typeof ReferralESignatureConsentPdf
  >['referral']
  consentStage: ReferralConsentStage
}

const FooterSection: React.FC<Props> = ({ referral, consentStage }) => {
  const { client, fromCompany } = referral
  const isPreview = !referral.id

  return (
    <PdfSection className="avoid-page-break">
      <div className="mb-4">
        <p className="mb-1">Yours</p>
        <p className="mb-4 font-bold">{fromCompany.presentationName}</p>
      </div>

      <div id={SIGNATURE_BOX_ID}>
        <div className="mb-2 flex items-center gap-1.5">
          <ESignatureUnderstandingCheckbox consentStage={consentStage} />
        </div>

        <div className="flex items-end gap-6 md:justify-between">
          <div>
            <div className="mb-1.5">
              <SignatureBox />
            </div>

            <p className="mb-0 font-bold">{client.fullName}</p>
          </div>

          <div
            className="rounded-md px-4 py-2 text-center"
            style={{
              backgroundColor: 'rgb(13, 150, 255, 0.1)',
              width: '165px',
            }}
          >
            {isPreview
              ? 'Date Signed'
              : formatDate(new Date(), DATE_FORMATS.DAY_MONTH_YEAR)}
          </div>
        </div>
      </div>
    </PdfSection>
  )
}

export default FooterSection
